import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@lib/shared';
import { Angulartics2Module } from 'angulartics2';
import { CoreModule } from 'lib/core';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    IonicModule,
    Angulartics2Module,
    HomeRoutingModule,
  ],
  declarations: [HomeComponent],
})
export class HomeModule {}
